import React from "react";
// Wrapper for minus.svg image created for fill and stoke color dynamically set
const MerchantsIcon = props => {
  const { width, height } = props
  return (
    <svg width={width} height={height} viewBox="0 0 60 60" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>0174_meno_150pt</title>
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Assets_icone" transform="translate(-1217.000000, -7854.000000)">
          <g id="0174_meno_150pt" transform="translate(1217.000000, 7854.000000)">
            <rect id="Rectangle" fill="#FFFFFF" opacity="0" x="0" y="0" width="60" height="60"></rect>
            <path d="M55.385,25.675 L34.325,25.675 L25.675,25.675 L4.615,25.675 C2.22636846,25.675 0.29,27.6113685 0.29,30 C0.29,32.3886315 2.22636846,34.325 4.615,34.325 L25.675,34.325 L34.325,34.325 L55.385,34.325 C56.9301737,34.325 58.3579731,33.5006597 59.13056,32.1625 C59.9031468,30.8243404 59.9031468,29.1756596 59.13056,27.8375 C58.3579731,26.4993403 56.9301737,25.675 55.385,25.675 Z" id="Path" fill="#000000" fill-rule="nonzero"></path>
          </g>
        </g>
      </g>
    </svg>
  )
}
export default MerchantsIcon